import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\'table__container\' ...attributes>\n  {{yield (component \'ui/table/table\' showStripes=(not-eq @showStripes false))}}\n</div>")